import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'HOURS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="flex flex-col items-center" data-id="element-19" data-mp="374vtr71x8i15">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-navy-700 sm:text-xs" data-id="element-20" data-mp="10c3f3m387q20">
        <ClockIcon className="h-4 w-4 text-grass-600" aria-hidden="true" data-id="element-21" data-mp="15a50wes1e3h6" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-center gap-2" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-22" data-mp="xzc1k06g4loq">
        {blocks.map((block, i) => <React.Fragment key={block.label} data-id="element-23" data-mp="12s50g7f8gzsw" data-mpi={i}>
            {i > 0 && <span className="text-xl font-bold text-navy-300" data-id="element-24" data-mp="12sokpuscw0a3">:</span>}
            <div className="flex w-[74px] flex-col items-center rounded-xl bg-navy-800 px-2 py-2.5 sm:w-[86px]" data-id="element-25" data-mp="f3dl4gmqsbxj">
              <span className="font-display text-3xl font-bold tabular-nums text-white sm:text-4xl" data-id="element-26" data-mp="a4sg83wjp42r">
                {block.value}
              </span>
              <span className="mt-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-navy-200" data-id="element-27" data-mp="k1nd6id66wex">
                {block.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}